import * as React from 'react';

var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
var SvgArrowUndoOutline = function SvgArrowUndoOutline(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.28033 2.71967C7.57322 3.01256 7.57322 3.48744 7.28033 3.78033L5.56066 5.5H14.25C18.116 5.5 21.25 8.63401 21.25 12.5C21.25 16.366 18.116 19.5 14.25 19.5H5.75C5.33579 19.5 5 19.1642 5 18.75C5 18.3358 5.33579 18 5.75 18H14.25C17.2876 18 19.75 15.5376 19.75 12.5C19.75 9.46243 17.2876 7 14.25 7H5.56066L7.28033 8.71967C7.57322 9.01256 7.57322 9.48744 7.28033 9.78033C6.98744 10.0732 6.51256 10.0732 6.21967 9.78033L3.21967 6.78033C2.92678 6.48744 2.92678 6.01256 3.21967 5.71967L6.21967 2.71967C6.51256 2.42678 6.98744 2.42678 7.28033 2.71967Z"
  })));
};

export { SvgArrowUndoOutline as ReactComponent };
//# sourceMappingURL=arrow-undo--outline.svg.js.map
